import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "placeholder-glow"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "placeholder col-12 skeleton-footer" }, null, -1)
      ])))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: _ctx.footerData.footer_content,
        dir: "ltr"
      }, null, 8, _hoisted_2))
}